var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentColor83(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 87,
    viewBox: "0 0 83 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2933 38.4145C63.2933 40.8466 63.2933 43.3199 63.2933 45.7932C63.2933 57.782 63.2933 69.7727 63.2933 81.7615C63.2933 85.1063 61.4102 86.998 58.0636 86.998C40.5223 86.9998 22.9827 87.0016 5.44132 86.998C1.85779 86.9962 0.00904475 85.135 0.00904475 81.5736C0.00904475 56.8783 0.00904475 32.1847 0 7.48944C0 6.08815 0.13748 4.74771 1.08899 3.62023C2.15446 2.36032 3.55097 1.88964 5.16998 1.89143C13.8945 1.89859 22.6209 1.89501 31.3455 1.89501C39.1077 1.89501 46.8699 1.90038 54.6321 1.88786C55.0391 1.88786 55.4805 1.81985 55.8495 1.65878C64.7314 -2.23012 74.9484 0.90534 80.0496 9.10191C87.0014 20.2693 81.0988 34.6026 68.2372 37.704C66.6742 38.0816 65.0408 38.1711 63.2933 38.4145ZM50.7917 4.67254C50.4642 4.67254 50.2255 4.67254 49.9867 4.67254C35.0647 4.67254 20.1426 4.67075 5.21882 4.67254C3.4171 4.67254 2.64107 5.44209 2.64107 7.22815C2.64107 32.0112 2.64107 56.7924 2.64107 81.5754C2.64107 83.4974 3.37007 84.224 5.2966 84.224C22.7457 84.2258 40.1967 84.2258 57.6458 84.2276C59.7803 84.2276 60.4026 83.6191 60.4026 81.5342C60.4026 67.3978 60.4026 53.2632 60.4026 39.1268C60.4026 38.7724 60.4026 38.4163 60.4026 38.0637C60.1747 37.9832 60.0101 37.9009 59.8364 37.8687C56.8607 37.3031 54.1871 36.088 51.7775 34.2625C51.4791 34.037 51.0051 33.9547 50.6108 33.9529C47.7834 33.9279 44.9542 33.9422 42.1268 33.9422C38.6373 33.9422 35.1461 33.9637 31.6584 33.9064C31.2008 33.8992 30.5803 33.5878 30.3451 33.2227C30.1299 32.8863 30.1498 32.1311 30.3994 31.8393C30.7087 31.4778 31.3599 31.238 31.8646 31.2344C37.0093 31.1915 42.1539 31.2094 47.2986 31.2094C47.6749 31.2094 48.0511 31.2094 48.4672 31.2094C42.1775 21.7261 42.9245 12.9604 50.7917 4.67254ZM80.122 19.0863C80.1093 10.0665 72.6745 2.72004 63.5629 2.72362C54.4801 2.7272 47.0381 10.1238 47.0471 19.1382C47.0562 28.1366 54.5217 35.5117 63.6153 35.5063C72.698 35.501 80.1346 28.1044 80.122 19.0863Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2152 16.368C7.7116 13.4652 7.61573 10.3978 9.99449 8.05156C12.3389 5.74113 16.2788 5.59438 18.7842 7.72405C21.4668 10.0058 21.5048 12.8675 18.862 16.5202C20.3308 17.3917 21.5103 18.5389 22.2827 20.0798C23.2668 22.0412 23.1673 24.1333 23.0135 26.2093C22.9502 27.0558 22.1615 27.2723 21.3764 27.2723C18.1908 27.2723 15.0053 27.2741 11.8197 27.2759C10.4069 27.2759 8.99414 27.2849 7.58316 27.2706C6.4996 27.258 6.10706 26.8267 6.05822 25.7386C5.94968 23.2904 6.0546 20.8779 7.71522 18.8753C8.44603 17.9877 9.34146 17.2324 10.2152 16.368ZM20.3145 24.5056C20.4611 22.1504 19.7031 20.2713 17.7205 19.0203C15.7017 17.7461 13.5961 17.7675 11.6099 19.0758C9.69602 20.3357 8.91093 22.179 9.15695 24.5056C12.8635 24.5056 16.5212 24.5056 20.3145 24.5056ZM14.6417 14.9453C16.5338 14.9757 18.1004 13.7301 18.2017 12.1158C18.312 10.3656 16.8576 8.91059 14.9112 8.82289C12.9431 8.7352 11.2571 10.0828 11.1848 11.8009C11.1142 13.4939 12.6772 14.9148 14.6417 14.9453Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3022 35.8501C26.3022 37.3105 26.3148 38.7708 26.2986 40.2294C26.2877 41.2406 25.83 41.7184 24.8134 41.7273C22.2284 41.747 19.6434 41.747 17.0584 41.7273C16.0744 41.7202 15.5968 41.271 15.5878 40.3064C15.5606 37.3857 15.5606 34.4667 15.5805 31.546C15.5878 30.56 16.0472 30.1197 17.0241 30.1143C19.6398 30.1 22.2537 30.1 24.8695 30.1179C25.8427 30.1251 26.2895 30.5886 26.3004 31.5586C26.3166 32.9885 26.304 34.4184 26.304 35.8484C26.304 35.8501 26.304 35.8501 26.3022 35.8501ZM18.388 32.8614C18.388 34.9142 18.388 36.8899 18.388 38.8943C20.1228 38.8943 21.8051 38.8943 23.4929 38.8943C23.4929 36.8416 23.4929 34.8694 23.4929 32.8614C21.7762 32.8614 20.1355 32.8614 18.388 32.8614Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3021 54.2155C26.3021 55.6454 26.3112 57.0754 26.2985 58.5071C26.2895 59.5934 25.8644 60.0247 24.7718 60.0301C22.2175 60.0426 19.6615 60.0426 17.1073 60.0301C16.0074 60.0247 15.5896 59.6167 15.5823 58.5017C15.5642 55.6419 15.5642 52.7802 15.5841 49.9204C15.5914 48.8591 16.0635 48.4224 17.1579 48.4171C19.6832 48.4045 22.2085 48.4028 24.7338 48.4189C25.8571 48.426 26.2931 48.8877 26.3021 50.0152C26.3094 51.4147 26.3021 52.8142 26.3021 54.2155ZM23.5001 57.1326C23.5001 55.0584 23.5001 53.0827 23.5001 51.0854C21.7653 51.0854 20.0993 51.0854 18.4151 51.0854C18.4151 53.131 18.4151 55.1282 18.4151 57.1326C20.1373 57.1326 21.7834 57.1326 23.5001 57.1326Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3021 72.4608C26.3021 73.8907 26.3148 75.3188 26.2985 76.7487C26.2876 77.7635 25.8336 78.2342 24.8152 78.2413C22.232 78.2592 19.6488 78.2592 17.0656 78.2413C16.0797 78.2342 15.5986 77.7921 15.5913 76.8293C15.566 73.8817 15.566 70.9324 15.5949 67.9848C15.604 67.0542 16.0653 66.639 17.015 66.6337C19.6289 66.6176 22.2428 66.6176 24.855 66.6337C25.7938 66.639 26.2858 67.1419 26.2985 68.0851C26.3166 69.5418 26.3021 71.0004 26.3021 72.4608ZM23.5037 75.4244C23.5037 73.3878 23.5037 71.4138 23.5037 69.413C21.7562 69.413 20.0703 69.413 18.4024 69.413C18.4024 71.4675 18.4024 73.4469 18.4024 75.4244C20.1336 75.4244 21.7996 75.4244 23.5037 75.4244Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4469 40.6301C38.9303 40.6283 35.4138 40.6516 31.899 40.6033C31.3888 40.5961 30.7394 40.3688 30.4193 40.0109C30.1642 39.7246 30.1244 38.9765 30.3306 38.6311C30.5549 38.2553 31.1609 37.9134 31.6168 37.8938C33.5361 37.8132 35.4626 37.8562 37.3855 37.8562C42.6459 37.8562 47.9045 37.8526 53.165 37.8597C54.3896 37.8615 54.9612 38.4038 54.8599 39.4132C54.7767 40.2471 54.2811 40.623 53.1794 40.6283C50.5944 40.6391 48.0095 40.6319 45.4245 40.6319C44.4296 40.6301 43.4382 40.6301 42.4469 40.6301Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5483 77.1427C39.0028 77.1427 35.4554 77.1624 31.9099 77.1212C31.416 77.1159 30.7594 76.9458 30.4826 76.6076C30.2113 76.2765 30.1371 75.5374 30.3325 75.1544C30.5242 74.7768 31.1519 74.4314 31.606 74.4063C33.2847 74.3186 34.9706 74.3687 36.6529 74.3687C42.1232 74.3687 47.5916 74.3705 53.0619 74.3687C53.818 74.3687 54.5398 74.4368 54.8057 75.2976C55.1313 76.3535 54.5018 77.1284 53.279 77.1373C50.3937 77.157 47.5084 77.1463 44.6232 77.1463C43.9321 77.1463 43.2411 77.1463 42.5501 77.1463C42.5483 77.1445 42.5483 77.1445 42.5483 77.1427Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4487 52.288C38.9032 52.288 35.3558 52.2862 31.8103 52.2898C31.103 52.2898 30.4916 52.152 30.222 51.3949C29.9181 50.5413 30.3595 49.7413 31.2549 49.5695C31.4883 49.5248 31.7325 49.5248 31.9731 49.5248C39.0063 49.523 46.0377 49.5212 53.0709 49.5248C54.2973 49.5248 54.8165 49.9095 54.8653 50.8062C54.916 51.7529 54.3715 52.2808 53.2699 52.2844C49.6628 52.2951 46.0558 52.288 42.4487 52.288Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4561 58.7828C38.9069 58.7828 35.356 58.7864 31.8068 58.781C30.7142 58.7792 30.1552 58.3354 30.1281 57.4745C30.0992 56.5744 30.6853 56.0715 31.8068 56.0715C38.9359 56.0679 46.0649 56.0733 53.194 56.0625C53.9248 56.0607 54.5182 56.2397 54.7895 56.9591C55.1603 57.9452 54.5326 58.7703 53.3767 58.7756C49.7353 58.7935 46.0957 58.7828 42.4561 58.7828Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4578 70.453C38.8779 70.453 35.298 70.4638 31.7181 70.4459C30.4862 70.4405 29.8603 69.6369 30.2203 68.6115C30.5043 67.8044 31.1573 67.7131 31.8936 67.7149C37.2481 67.722 42.6025 67.7167 47.9588 67.7167C49.7045 67.7167 51.4483 67.7131 53.1939 67.7202C54.292 67.7256 54.8799 68.2357 54.8654 69.1448C54.8509 70.0253 54.339 70.4459 53.1994 70.4494C49.6177 70.4602 46.0377 70.4548 42.4578 70.453Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1487 11.7204C58.1487 16.6795 58.1487 21.524 58.1487 26.5028C58.5666 26.5028 58.9465 26.5028 59.3263 26.5028C62.9062 26.5028 66.4861 26.5028 70.0661 26.5046C70.3356 26.5046 70.6124 26.4921 70.8765 26.535C71.5584 26.646 71.96 27.0451 71.9582 27.7466C71.9564 28.4643 71.5964 28.9439 70.8584 29.0459C70.4441 29.1032 70.0172 29.0763 69.5975 29.0763C65.4768 29.0799 61.3542 29.0835 57.2334 29.0799C55.6849 29.0781 55.3539 28.7309 55.3539 27.1721C55.3557 21.7155 55.3539 16.2589 55.3557 10.8005C55.3557 9.36876 55.7193 9.00725 57.1628 9.00725C61.555 9.00546 65.9471 9.01083 70.3392 8.9983C71.1134 8.99651 71.7176 9.20411 71.9293 10.0059C72.1898 10.9866 71.5693 11.7114 70.4477 11.715C66.9583 11.7275 63.4688 11.7204 59.9794 11.7221C59.4095 11.7204 58.8397 11.7204 58.1487 11.7204Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6356 20.1998C66.459 18.3851 68.1052 16.7386 69.764 15.1011C69.9937 14.8738 70.2488 14.634 70.54 14.5141C71.1695 14.2528 71.8099 14.2975 72.2513 14.8684C72.6927 15.4375 72.6348 16.0675 72.1319 16.574C69.9792 18.7341 67.8194 20.8906 65.6305 23.0131C65.0625 23.5643 64.3498 23.5464 63.7673 22.9934C62.7471 22.027 61.7485 21.0373 60.7771 20.0208C60.229 19.4463 60.2724 18.7108 60.7934 18.1793C61.3397 17.6227 62.1067 17.5815 62.7163 18.1614C63.3639 18.777 63.9482 19.4607 64.6356 20.1998Z",
    fill: "url(#paint11_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -2.09768,
    y1: 82.6211,
    x2: 70.6333,
    y2: -1.37089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26CFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -24.2239,
    y1: 63.3211,
    x2: 48.5071,
    y2: -20.6709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26CFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -12.3847,
    y1: 73.573,
    x2: 60.3464,
    y2: -10.4189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26CFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: -3.20289,
    y1: 81.5238,
    x2: 69.5281,
    y2: -2.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26CFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 5.90522,
    y1: 89.4107,
    x2: 78.6363,
    y2: 5.41866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26CFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1.53916,
    y1: 85.6299,
    x2: 74.27,
    y2: 1.63798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26CFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 19.826,
    y1: 101.465,
    x2: 92.5571,
    y2: 17.4733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26CFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 7.34726,
    y1: 90.6595,
    x2: 80.0783,
    y2: 6.66757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26CFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 10.6087,
    y1: 93.484,
    x2: 83.3402,
    y2: 9.49197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26CFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 16.4582,
    y1: 98.5491,
    x2: 89.1893,
    y2: 14.5571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26CFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 3.35681,
    y1: 87.204,
    x2: 76.0878,
    y2: 3.2121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26CFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 4.10996,
    y1: 87.8563,
    x2: 76.841,
    y2: 3.86436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26CFA0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 87,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentColor83);
export default __webpack_public_path__ + "static/media/document-color-83.1b8fa6c2fd4db8b4e658181c8fdc5ce2.svg";
export { ForwardRef as ReactComponent };